"use client";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../UI/Button/Button";
import Input from "../UI/Input/Input";
import Label from "../UI/Label/Label";
import Card from "../UI/Card/Card";
// import { fetchPatientData } from "../../services/data-service"
import "./HomePage.css";

function HomePage() {
  const [uhid, setUhid] = useState(""); // Default value for demo
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!name || !phone) {
      setError("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      navigate(`/mapping?uhid=${uhid}`);
    } catch (err) {
      console.error("Error fetching patient data:", err);
      setError(
        "Failed to fetch patient data. Please check the UHID and try again."
      );
      setLoading(false);
    }
  };

  return (
    <div className="home-container">
      <div className="home-content slide-up">
        <Card className="home-card">
          <div className="card-header">
            <h2 className="card-title">Start New Assessment</h2>
            <p className="card-description">
              Enter patient information to begin the AICVD risk assessment
            </p>
          </div>
          <div className="card-content">
            <form onSubmit={handleSubmit} className="form-container">
              <div className="form-group">
                <Label htmlFor="uhid">UHID</Label>
                <Input
                  id="uhid"
                  placeholder="Enter UHID"
                  value={uhid}
                  onChange={(e) => setUhid(e.target.value)}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <Label htmlFor="name">Name</Label>
                  <Input
                    id="name"
                    placeholder="Enter patient name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <Label htmlFor="phone">Phone Number</Label>
                  <Input
                    id="phone"
                    placeholder="Enter phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    className="form-input"
                  />
                </div>
              </div>
              {error && <div className="error-message">{error}</div>}

              <Button
                type="submit"
                disabled={loading}
                className="submit-button"
              >
                {loading ? (
                  <span className="loading-text">
                    <span className="loading-dots"></span>
                    Processing
                  </span>
                ) : (
                  "Begin Assessment"
                )}
              </Button>
            </form>
          </div>
          <h3 className="card-sub-heading-title">Bridging Epic EMR data for Apollo Clinical AI Predictive Intelligence </h3>

        </Card>
      </div>
    </div>
  );
}

export default HomePage;
